"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _flex = _interopRequireDefault(require("@influitive/secret-garden/lib/flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItem = function ListItem(_ref) {
  var media = _ref.media,
      left = _ref.left,
      right = _ref.right;
  return (0, _core.jsx)(_flex.default, {
    alignItems: "center",
    justifyContent: "space-between"
  }, (0, _core.jsx)(_flex.default, null, media, (0, _core.jsx)(_flex.default, {
    alignItems: "center"
  }, left)), right);
};

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  media: _propTypes.default.node,
  left: _propTypes.default.node,
  right: _propTypes.default.node
}), (0, _recompose.setDisplayName)('ListItem'))(ListItem);

exports.default = _default;